import RegistrationDetail from './RegistrationDetail';

export default RegistrationDetail;
